import { Form, Formik } from "formik";
import { Link, useNavigate } from "react-router-dom"; // Use useNavigate for navigation
import { ReactComponent as Logo } from "../../assets/rentisity-logo.svg";
import Button from "../../designComponents/Button";
import Input from "../../designComponents/Input";
import Typography from "../../designComponents/Typography";
import requestAPI from "../../utils/requestAPI";
import { ContainerStyled, LoginWrapperStyled } from "../Login/styles";
import users from "../../apiConfigs/users";
import { toast } from "react-toastify";
import { FORGOT_PASSWORD_RESET_ROUTE } from "../../routes/routePaths";
import { useState } from "react";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleForgotPassword = async (email: string) => {
    setLoading(true);
    try {
      await requestAPI(users.forgotPassword(email));
      toast.success("Successfully sent");
      navigate(`${FORGOT_PASSWORD_RESET_ROUTE}?email=${email}`);
    } catch (error: any) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <LoginWrapperStyled>
      <ContainerStyled>
        <div className="header">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Logo width={150} style={{ marginBottom: "30px" }} />
            <Typography
              variant="h1"
              fontWeight="bold"
              size="largeTitle"
              color="primary"
              fontFamily="poppins"
            >
              Forgot Password?
            </Typography>
          </div>
          <Typography
            size="h5"
            fontWeight="light"
            fontFamily="urbanist"
            style={{ color: "#5F5F5F" }}
          >
            Enter your email address we’ll sent a reset instruction into your
            account.
          </Typography>
        </div>

        <Formik initialValues={{ email: "" }} onSubmit={() => {}}>
          {({ values, setFieldValue, errors, touched }) => {
            return (
              <Form>
                <div className="form-container">
                  <Typography
                    style={{
                      fontSize: 12,
                      color: "#5F5F5F",
                      fontWeight: "600",
                    }}
                  >
                    Email
                  </Typography>
                  <Input
                    placeholder="alma.lawson@example.com"
                    radius="15px"
                    name="email"
                    value={values.email}
                    style={{ borderWidth: "1px solid f1effb" }}
                    onChange={(e) => setFieldValue("email", e.target.value)}
                  />
                  {errors.email && touched.email ? (
                    <Typography color="status.red" size="subtitle">
                      {errors.email}
                    </Typography>
                  ) : (
                    ""
                  )}
                </div>

                <Button
                  fullWidth
                  isLoading={loading}
                  onClick={() => {
                    handleForgotPassword(values.email);
                  }}
                >
                  Send Mail
                </Button>
              </Form>
            );
          }}
        </Formik>
        <div style={{ display: "flex", justifyContent: "center", padding: 10 }}>
          <Link to={"/login"}>
            <Typography
              style={{ color: "#003DA8", textDecoration: "underline" }}
            >
              {" "}
              Back to Login{" "}
            </Typography>
          </Link>
        </div>
      </ContainerStyled>
    </LoginWrapperStyled>
  );
};

export default ForgotPassword;
